import React from 'react';
import { t } from '@lingui/macro';
import { Text } from '@cardboard-ui/react';
import { Owner } from 'components/ownership/Owner';
import { notEmpty } from 'utils/NotEmptyFilter';
import { OwnerPanel, OwnerPanelTitle } from '../ownership/OwnerPanel';
import { OwnersPanelProps } from './SpaceItemAccessDetails';

export const ImplicitOwners = ({ ownerships }: OwnersPanelProps) => {
  const implicitOwners =
    ownerships?.edges
      ?.filter(notEmpty)
      .filter(
        (owner) =>
          owner.node?.ownerOf.edges?.length &&
          owner.node.ownerOf.edges.length > 0 &&
          owner.node.member.status?.value !== 'DELETED',
      ) || [];

  return (
    <OwnerPanel title={<OwnerPanelTitle>{t`Implicit owners`}</OwnerPanelTitle>}>
      {implicitOwners.length === 0 ? (
        <Text>{t`No implicit owners`}</Text>
      ) : (
        implicitOwners.map((owner) => {
          return (
            <Owner
              isImplicit
              key={owner.node?.member.id}
              ownership={owner!.node!}
            />
          );
        })
      )}
    </OwnerPanel>
  );
};
